var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDrawerClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 19,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1339_13938)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 20.0308L13.7339 25.2937C13.5994 25.4312 13.4129 25.5059 13.221 25.4996C12.9299 25.4973 12.6687 25.3212 12.557 25.0531C12.4445 24.7842 12.5035 24.4752 12.7065 24.2669L17.9726 19.004L12.7065 13.7412C12.5688 13.6068 12.4941 13.4205 12.5004 13.2286C12.4956 13.036 12.5704 12.8505 12.7065 12.7144C12.8426 12.5784 13.0282 12.5037 13.221 12.5085C13.4129 12.5022 13.5994 12.5769 13.7339 12.7144L19 17.9772L24.2661 12.7144C24.4722 12.5053 24.7853 12.4424 25.0567 12.5556C25.3274 12.6688 25.5028 12.9346 25.4996 13.2286C25.5059 13.4205 25.4312 13.6068 25.2935 13.7412L20.0274 19.0041L25.2935 24.2669C25.561 24.553 25.5539 24.9996 25.2762 25.2764C24.9993 25.5539 24.5524 25.561 24.2661 25.2936L19 20.0308Z",
    fill: "#0A0A0A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1339_13938"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(11 11)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrawerClose);
export default __webpack_public_path__ + "static/media/drawer_close.a9c4f3b6baf8fc4e39a14df3b334c772.svg";
export { ForwardRef as ReactComponent };